module.exports = __webpack_public_path__ + "img/demo1.41e853d0.webp";